import React from 'react';
import { TrendingUp, Users, MessageCircle, Heart, Target, Zap, ArrowRight } from 'lucide-react';
import { measurableOutcomes } from '../data/mock';
import { Button } from './ui/button';
import { trackCTAClick } from '../utils/analytics';

const outcomeIcons = [TrendingUp, Users, MessageCircle, Heart, Target, Zap];

const MeasurableResults = () => {
  const scrollToConsultation = () => {
    trackCTAClick('Schedule a Leadership Strategy Session', 'measurable_results');
    const element = document.querySelector('#consultation');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="measure-results" className="py-16 sm:py-24 bg-slate-950 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/4 w-[500px] h-[500px] bg-emerald-500/5 rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <span className="text-emerald-400 text-sm font-semibold tracking-widest uppercase mb-4 block">
            Performance Improvement
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-white mb-4 sm:mb-6">
            How We Measure
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-cyan-400">
              Results
            </span>
          </h2>
          <p className="text-slate-400 text-base sm:text-lg max-w-3xl mx-auto">
            This isn't just training—it's performance improvement. We focus on measurable 
            outcomes that impact your organization's bottom line.
          </p>
        </div>

        {/* Outcomes Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-12">
          {measurableOutcomes.map((outcome, index) => {
            const IconComponent = outcomeIcons[index];
            return (
              <div
                key={index}
                className="group p-6 rounded-2xl bg-white/[0.02] border border-white/10 hover:border-emerald-500/30 hover:bg-white/[0.04] transition-all duration-300"
              >
                {/* Icon */}
                <div className="w-12 h-12 rounded-xl bg-emerald-500/10 flex items-center justify-center mb-4 group-hover:bg-emerald-500/20 transition-colors">
                  <IconComponent className="h-6 w-6 text-emerald-400" />
                </div>

                {/* Label */}
                <h3 className="text-white font-bold text-lg mb-2 group-hover:text-emerald-400 transition-colors">
                  {outcome.label}
                </h3>

                {/* Description */}
                <p className="text-slate-400 text-sm leading-relaxed">
                  {outcome.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Button
            onClick={scrollToConsultation}
            data-testid="measurable-results-cta-button"
            className="bg-emerald-500 hover:bg-emerald-400 text-white font-semibold px-8 py-6 text-lg transition-all duration-300 hover:shadow-lg hover:shadow-emerald-500/25"
          >
            Schedule a Leadership Strategy Session
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
          <p className="text-slate-500 text-sm mt-4">
            Eligible organizations may qualify for workforce training funding.
          </p>
        </div>
      </div>
    </section>
  );
};

export default MeasurableResults;
